import React from 'react'
import { Link, useLocation } from "react-router-dom";
import "./menu.scss"

export default function Menu({menuOpen, setMenuOpen}) {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className={"menu " + (menuOpen && "active")}>
      <ul>
        {isHomePage ? (
          <>
            <li onClick={() => setMenuOpen(false)}>
              <a href="#intro">Home</a>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <a href="#about">About</a>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <a href="#skills">Skills</a>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <a href="#works">Works</a>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <Link to="/my-portfolio">My Portfolio</Link>
            </li>
          </>
        ) : (
          <>
            <li onClick={() => setMenuOpen(false)}>
              <Link to="/#intro">Home</Link>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <Link to="/#about">About</Link>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <Link to="/#skills">Skills</Link>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <Link to="/#works">Works</Link>
            </li>
            <li onClick={() => setMenuOpen(false)}>
              <Link to="/my-portfolio">My Portfolio</Link>
            </li>
          </>
        )}
      </ul>
    </div>
  )
}
